import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import parse from 'html-react-parser';
import Button from '../../../ui-core/Button/Button';
import LazyImage from '../../../ui-core/Image';
import { TEXT_CONSTANT, IMAGE_CONSTANT } from '../../../constants/app';
import { formatCurrency } from '../../../utils/helpers';

import './style.css';

const JoinPlan = props => {
  const { isLoading, courseDetail } = props;

  const currentPrice = useMemo(() => {
    return courseDetail?.attributes?.amount
      ? +courseDetail?.attributes?.amount / 100
      : 0;
  }, [courseDetail?.attributes?.amount]);

  const originalPrice = useMemo(() => {
    return currentPrice + (courseDetail?.attributes?.discount || 0);
  }, [currentPrice, courseDetail?.attributes?.discount]);

  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.JOIN_THE_COURSE,
        'isSignup',
        TEXT_CONSTANT.REBUILD_FOOT_HEALTH,
      );
    }
  };

  return (
    <Row className="foot-health row-margin-zero">
      <Col
        className="d-flex justify-content-center align-items-center px-4"
        xs={12}
        md={6}
      >
        <div className="foot-health-div text-start d-flex flex-column">
          <h2 className="bold">{TEXT_CONSTANT.REBUILD_FOOT_HEALTH}</h2>
          <p>{parse(TEXT_CONSTANT.REBUILD_FOOT_HEALTH_DESCRIPTION)}</p>
          <span>
            <b className="bold">{TEXT_CONSTANT.BFM_DOCUMENT}</b>
          </span>
          {Boolean(courseDetail?.attributes?.amount) && (
            <div className="d-flex">
              {Boolean(courseDetail?.attributes?.discount) && (
                <p className="foot-health-price-cut">
                  {formatCurrency(
                    originalPrice,
                    courseDetail?.attributes?.currency,
                    2,
                  )}
                </p>
              )}
              <p className="foot-health-price">
                {formatCurrency(
                  currentPrice,
                  courseDetail?.attributes?.currency,
                  2,
                )}
              </p>
              {props?.courseDetail?.attributes?.discount > 0 ? (
                <div className="foot-health-para-div">
                  <p className="foot-health-para">For a limited time</p>
                </div>
              ) : (
                ''
              )}
            </div>
          )}
          <Button
            onClick={handleClick}
            isDisabled={isLoading}
            isLoading={isLoading}
            text={TEXT_CONSTANT.JOIN_THE_COURSE}
            class="sign-up-button-new d-inline-block mb-3 text-uppercase"
            display
          />
        </div>
      </Col>
      <Col className="p-0 vid-wrapper" xs={12} md={6}>
        <LazyImage
          className="w-100"
          errorSrc={IMAGE_CONSTANT.rebuildFootHealth}
          placeholderSrc={IMAGE_CONSTANT.rebuildFootHealthLow}
          src={IMAGE_CONSTANT.rebuildFootHealthWebp}
        />
      </Col>
    </Row>
  );
};

JoinPlan.propTypes = {
  courseDetail: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default JoinPlan;
